import React, { useEffect, useMemo } from 'react';
import { Box, FlatTextInput, Inscription } from '@common-fe/common-fe';

import { LockboxStatus, LockboxType } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

export const useGetForBenefitOf = () => {
  const { editableLockbox } = useLockboxDetailsStore();
  const [isOutbound, isInbound] = useMemo(() => [
    editableLockbox?.lockboxType === LockboxType.OUTBOUND_TOA,
    editableLockbox?.lockboxType === LockboxType.INBOUND_TOA,
  ], [editableLockbox]);

  if (!isOutbound && !isInbound) return undefined;
  if (isOutbound && editableLockbox?.lockboxStatus !== LockboxStatus.APPROVED) return undefined;
  if (isInbound && editableLockbox?.lockboxStatus !== LockboxStatus.DECLINED) return undefined;

  return { isOutbound, isInbound };
};

const ForBenefitOf = () => {
  const { editableLockbox, originalLockbox, isEditMode, setEditableLockbox } = useLockboxDetailsStore();
  const forBenefitOfStatus = useGetForBenefitOf();
  
  useEffect(() => {
    if (forBenefitOfStatus?.isOutbound && !editableLockbox?.checkBenefitOf && editableLockbox?.employeeName) {
      setEditableLockbox({
        checkBenefitOf: editableLockbox?.employeeName,
      });
    }

    if (forBenefitOfStatus?.isInbound && originalLockbox?.checkDetails?.benefitOf) {
      setEditableLockbox({
        checkBenefitOf: originalLockbox?.checkDetails?.benefitOf,
      });
    }

    return () => {
      setEditableLockbox({
        checkBenefitOf: '',
      });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableLockbox?.lockboxStatus]);

  if (!forBenefitOfStatus) return null;

  return (
    <Box data-testid={`ForBenefitOf_${editableLockbox?.lockboxType}`}>
      <Inscription color="textSecondary" lineHeight="20px" margin={{ vertical: 'spacing12' }}>For benefit of</Inscription>
      <FlatTextInput
        testId="ForBenefitOf"
        name="forBenefitOf"
        placeholder="For benefit of"
        onChange={(val?: string) => setEditableLockbox({
          checkBenefitOf: val,
        })}
        value={editableLockbox?.checkBenefitOf}
        ellipsisMode
        disabled={!isEditMode}
      />
    </Box>
  );
};

export default ForBenefitOf;
